import script from "./EditPayComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./EditPayComponent.vue?vue&type=script&setup=true&lang=js"

import "./EditPayComponent.vue?vue&type=style&index=0&id=52d76361&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52d76361"]])

export default __exports__